module.exports = __webpack_public_path__ + "img/to_top.50dadf72.svg";